import React from 'react';
import LazyImage from '../../components/LazyImage';

const AboutSection: React.FC = () => {
  return (
    <section className="bg-[#EDF1F9] py-16 md:py-20">
      <div className="mx-auto px-4 md:px-10 lg:px-32 w-full">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-12 lg:gap-12 items-center">
            {/* Text Content - Left Side */}
            <div className="space-y-6 order-1 lg:order-1">
              <p className="text-[16px] md:text-[20px] lg:text-[18px] lg:leading-[23px] text-[#000] font-[400]">
                Welcome to <strong>The Wealthy Miner</strong> — where serious resource investors come for no-hype analysis, real portfolio insights, and strategies that have stood the test of time.
              </p>
              
              <p className="text-[16px] md:text-[20px] lg:text-[18px] lg:leading-[23px] text-[#000] font-[400]">
                I'm <strong>Rob Bruggeman</strong>. Over more than twenty years as an analyst at top Bay Street banks and as a private investor in the resource sector, I've analyzed hundreds of junior mining companies. These ten tips are the ones that have consistently helped me avoid disasters and capture outsized returns — up to 5x, 10x, and higher.
              </p>
              
              <p className="text-[16px] md:text-[20px] lg:text-[18px] lg:leading-[23px] text-[#000] font-[400]">
              There is no guaranteed path to 10-baggers in junior mining. If there were, we'd all be billionaires. But these principles dramatically  <strong>improve your odds by focusing on what actually matters</strong>: people, projects, and discipline.
              </p>
            </div>

            {/* Circular Image - Right Side */}
            <div className="flex justify-center lg:justify-end order-2 lg:order-2 ">
              <div className="relative w-72 h-72 md:w-72 md:h-72 lg:w-[316px] lg:h-[331px] ">
                <div className="w-full h-full rounded-full overflow-hidden bg-[#FFFFFF] pt-2">
                  <LazyImage 
                    src="/images/RobertBruggeman.webp" 
                    alt="Rob Bruggeman" 
                    className="w-full h-full rounded-full object-cover"
                    sizes="(max-width: 1024px) 320px, 384px"
                    backgroundColor="#FFFFFF"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
